var $window = $(window),
        $html = $('.spec-table .spec-row');

    function resize() {
        $html.each(function() {
            if ($(this)[0].scrollWidth > $window.width()) {
                return $(this).parent('.spec-table').addClass('has-gradient-right');
            }
            
        });
    }

    $window
        .on('resize', function() {resize();})
        .trigger('resize');